module.exports = __webpack_public_path__ + "static/img/IMG_0868.91b16df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0868.jpg
// module id = MXwI
// module chunks = 12